/** DOM `id` on the store product listing header (`ListingHeader` in stadium-shops). */
export const PRODUCT_LISTING_HEADER_ANCHOR_ID = "product-listing-header-anchor";

/** Scrolls that header into view when present; no-op if the node is not in the document. */
export function scrollProductListingHeaderIntoView() {
  if (typeof document === "undefined") return;

  const run = () => {
    document
      .getElementById(PRODUCT_LISTING_HEADER_ANCHOR_ID)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  requestAnimationFrame(() => requestAnimationFrame(run));
}
